<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>Input</v-card-title>
          <ValidationObserver ref="form" v-slot="{ invalid }" immediate>
            <v-form v-model="valid">
              <v-container>
                <v-row dense>
                  <v-col cols="2">
                    <v-btn
                      text
                      color="primary"
                      href="sample_files/select_samples_for_vec_search.fasta"
                    >
                      Search file sample
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      text
                      color="primary"
                      href="sample_files/select_samples_for_vec_ref.fasta"
                    >
                      Reference file sample
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="Search file"
                      rules="required"
                    >
                      <v-file-input
                        label="Search file"
                        v-model="searchFile"
                        :error-messages="errors"
                        :success="valid">
                      </v-file-input>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="Reference file"
                      rules="required"
                    >
                      <v-file-input
                        label="Reference file"
                        v-model="referenceFile"
                        :error-messages="errors"
                        :success="valid">
                      </v-file-input>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="EC first digit of reference"
                      rules="required"
                    >
                      <v-select
                        label="EC first digit of reference"
                        v-model="selectDigit"
                        :items="digits"
                        :error-messages="errors"
                        :success="valid"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="The number of the selected sequences from search file"
                      rules="required|integer"
                    >
                      <v-text-field
                        label="The number of the selected sequences from search file"
                        v-model="selectNum"
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="n_neighbors"
                      rules="required|integer"
                    >
                      <v-text-field
                        label="n_neighbors"
                        v-model="nNeighbors"
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="metric"
                      rules="required"
                    >
                      <v-select
                        label="metric"
                        v-model="selectMetric"
                        :items="metrics"
                        :error-messages="errors"
                        :success="valid"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions class="d-flex justify-end">
                <v-btn @click="upload" :disabled="invalid">Submit</v-btn>
                <v-btn @click="clear">Clear</v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import axios from 'axios';
import router from "../router";

let instance = null;

export default {
  data: () => ({
    valid: true,
    referenceFile: null,
    searchFile: null,
    selectNum: 10,
    nNeighbors: 15,
    digits: [...Array(6)].map((_, i) => i + 1),
    selectDigit: null,
    metrics: [
      'euclidean',
      'cosine',
      'correlation',
    ],
    selectMetric: null,
  }),
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    ...mapActions("util", ["showProgress", "hideProgress", "openSnackbar", "closeSnackbar", ]),
    // ログインチェック
    checkLoggedIn: function() {
      this.$session.start();
      if (this.$session.has("token")) {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        instance = axios.create({
          headers: {
            Authorization: "JWT " + this.$session.get('token'),
          }
        })
      } else {
        router.push("/login");
      }
    },
    // 入力クリア
    clear: function() {
      this.referenceFile = null;
      this.searchFile = null;
      this.selectNum = 10;
      this.nNeighbors = 15;
      this.selectDigit = null;
      this.selectMetric = null;
    },
    // ファイルアップロード
    upload: function() {
      this.showProgress();

      const formData = new FormData();
      formData.append('user', this.$store.state.userName);
      formData.append('referenceFile', this.referenceFile);
      formData.append('searchFile', this.searchFile);
      formData.append('ec1d', this.selectDigit);
      formData.append('selectNum', this.selectNum);
      formData.append('nNeighbors', this.nNeighbors);
      formData.append('metric', this.selectMetric);

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        }
      }

      const url = '/api/upload_vv/';
      instance.post(url, formData, config).then((response) => {
        if (response.status === 200) {
          this.hideProgress();
          this.btnDisabled = false;
          this.openSnackbar({ text:'File was uploaded. Please check the result on Result Inquiry screen.', color:'success' });
        } else {
          this.hideProgress();
          this.openSnackbar({ text:'File upload failed.', color:'error' });
        }
      }).catch(() => {
        this.hideProgress();
        this.openSnackbar({ text:'File upload failed.', color:'error' });
      });
    },
  }
};
</script>
